module.exports = __webpack_public_path__ + "static/fonts/icomoon.5ecbcd26.ttf";